<template>
  <div class="start-screen" ref="aside">
    <aside-block class="start-screen__aside"></aside-block>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapState, mapMutations } from 'vuex'
import SliderBlock from './SliderBlock.vue'
import SliderMobile from './SliderMobile'
import AsideBlock from './AsideBlock.vue'


export default {
  name:"StartScreen",
  components: {
    SliderBlock,
    AsideBlock,
    SliderMobile,
  },
  data: () => ({

  }),
  computed: {

  },
  methods: {
    ...mapMutations(['toggleStartScreen']),
  }
}
</script>

<style lang="stylus">
.start-screen
  width 100vw
  height 100vh
  box-sizing border-box
  &.fixed
    position fixed
</style>